const state = {
    errorMessages:        [],
    successMessages:      [],
    notificationSettings: {},
};

const getters = {
    getErrorMessages:        state => state.errorMessages,
    getSuccessMessages:      state => state.successMessages,
    getNotificationSettings: state => state.notificationSettings,
};

const mutations = {
    SET_ERROR_MESSAGES(state, payload) {
        state.errorMessages = payload;
    },
    SET_SUCCESS_MESSAGES(state, payload) {
        state.successMessages = payload;
    },
    SET_NOTIFICATION_SETTINGS(state, payload) {
        state.notificationSettings = payload;
    },
};

const actions = {
    setErrorMessages({commit}, messages) {
        commit('SET_ERROR_MESSAGES', messages);
    },
    setSuccessMessages({commit}, message) {
        commit('SET_SUCCESS_MESSAGES', message);
    },
    setNotificationSettings({commit}, position) {
        commit('SET_NOTIFICATION_SETTINGS', position);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
